// extracted by mini-css-extract-plugin
export default {"emoji":"TextWithEmoji_emoji__ocmwr"};